/* HTML */
export default function ShortIntroTitle( { children } )
{
    return(
        <h3 className='title'>
            {children}
        </h3>
    )
}